// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editable-cell {
    position: relative;
  }
  
  .editable-cell-value-wrap {
    padding: 5px 12px;
    cursor: pointer;
  }
  
  .editable-row:hover .editable-cell-value-wrap {
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/MRM/Drawer/temp.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;EACpB","sourcesContent":[".editable-cell {\n    position: relative;\n  }\n  \n  .editable-cell-value-wrap {\n    padding: 5px 12px;\n    cursor: pointer;\n  }\n  \n  .editable-row:hover .editable-cell-value-wrap {\n    padding: 4px 11px;\n    border: 1px solid #d9d9d9;\n    border-radius: 2px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
